import PropTypes from 'prop-types';
import styles from './EmailCaptureButton.module.css';
import classNames from 'classnames';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';

const EmailCaptureButton = ({ isDisabled, isLoading }) => {
  const {
    callToActionButtonText,
    callToActionButtonLoadingText,
    callToActionButtonTextColor: color,
    callToActionButtonBackgroundColor: backgroundColor,
    callToActionButtonBorderRadius: borderRadius,
    callToActionButtonBorderWidth: borderWidth,
    callToActionButtonBorderStyle: borderStyle,
    callToActionButtonBorderColor: borderColor,
  } = useSearchParamOrDefaultProps();

  const emailCaptureButton = classNames(styles.emailCaptureButton, {
    [styles.emailCaptureButtonDisabled]: isDisabled,
  });

  const style = {
    color,
    backgroundColor,
    borderRadius,
    borderColor,
    borderStyle,
    borderWidth,
  };

  return (
    <button
      type="submit"
      style={style}
      disabled={isDisabled}
      aria-disabled={isDisabled}
      className={emailCaptureButton}
      aria-label={callToActionButtonText}
    >
      {isLoading ? callToActionButtonLoadingText : callToActionButtonText}
    </button>
  );
};

EmailCaptureButton.displayName = 'EmailCaptureButton';

EmailCaptureButton.defaultProps = {
  isDisabled: false,
  isLoading: false,
};

EmailCaptureButton.propTypes = {
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default EmailCaptureButton;
